import { Modal } from "@mgdx/ui/components/Modal";

import { AgreementNewTermsReasonView, AgreementNewTermsReasonViewProps } from "../../views/AgreementNewTermsReasonView";

export const AgreementNewTermsReasonModal = ({
  onClickAgreement,
  onClickShowWithdraw,
}: AgreementNewTermsReasonViewProps) => {
  return (
    <Modal open={true} size="full">
      <AgreementNewTermsReasonView onClickAgreement={onClickAgreement} onClickShowWithdraw={onClickShowWithdraw} />
    </Modal>
  );
};
